var _path, _path2, _path3, _path4, _path5, _path6, _path7, _linearGradient, _path8, _defs, _path9, _polygon, _polygon2, _polygon3, _circle, _defs2, _mask, _linearGradient2, _path10, _linearGradient3, _path11, _g, _linearGradient4, _path12, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _linearGradient5, _ellipse, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWomenWebDeveloperWithLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 800 600",
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M111.86 449.42c0 0-22.1-11.63-29.76-28.56-7.66-16.93-.18-40.65-2.48-48.61 14.14 14.95 22.83 19.29 29.01 36.54C114.81 426.03 113.02 444.57 111.86 449.42zM135.15 477.64c0 0-22.75 18.03-46.69.62-16.74-14.1-27.88-33.34-27.88-33.34s26.91 3.63 40.37 6.8C114.41 454.9 130.32 470.47 135.15 477.64zM704.07 449.42c0 0 22.1-11.63 29.76-28.56 7.66-16.93.18-40.65 2.48-48.61-14.14 14.95-22.83 19.29-29.01 36.54C701.12 426.03 702.92 444.57 704.07 449.42zM680.78 477.64c0 0 22.75 18.03 46.69.62 16.74-14.1 27.88-33.34 27.88-33.34s-26.91 3.63-40.37 6.8C701.52 454.9 685.61 470.47 680.78 477.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M220.07,544.46c0,0-22.47,19.4-80.47,4.76c-42.27-10.67-77.1-52.41-77.1-52.41S145.48,465.39,220.07,544.46z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M218.19,547.07c0,0-44.68-5.2-87.78-84.93c-31.42-58.11-20.53-139.76-20.53-139.76 S229.99,382.79,218.19,547.07z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M216.48,545.43c0,0-35.54-27.58-31.16-118.1c3.19-65.98,54.77-130.21,54.77-130.21 S311.6,410.97,216.48,545.43z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M592.61,541.09c0,0,22.19,19.16,79.47,4.7c41.75-10.54,76.14-51.75,76.14-51.75S666.28,463,592.61,541.09z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M595.87,547.07c0,0,44.68-5.2,87.78-84.93c31.42-58.11,20.53-139.76,20.53-139.76 S584.07,382.79,595.87,547.07z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M597.58,545.43c0,0,35.54-27.58,31.16-118.1c-3.2-65.98-54.77-130.21-54.77-130.21 S502.46,410.97,597.58,545.43z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 409.947,
    x2: 409.947,
    y1: 4.696,
    y2: 547.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M711.33,311.78c0-166.45-134.93-301.38-301.38-301.38c-166.45,0-301.38,134.93-301.38,301.38 c0,94.95,43.92,179.62,112.54,234.86h377.69C667.4,491.4,711.33,406.73,711.33,311.78z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 381,
    height: 278,
    x: 220,
    y: 270,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M375.43 103.15c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19s.53-1.19 1.19-1.19C374.9 101.96 375.43 102.5 375.43 103.15zM460.43 176.61c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19 0-.66.53-1.19 1.19-1.19C459.9 175.42 460.43 175.95 460.43 176.61zM318.86 194.89c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19 0-.66.53-1.19 1.19-1.19C318.33 193.7 318.86 194.23 318.86 194.89zM228.89 180.52c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19 0-.66.53-1.19 1.19-1.19C228.35 179.33 228.89 179.86 228.89 180.52zM577.48 252.89c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19s.53-1.19 1.19-1.19C576.95 251.7 577.48 252.23 577.48 252.89z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#619fff",
    points: "581.38 173.68 582.64 176.24 585.47 176.65 583.42 178.65 583.91 181.47 581.38 180.14 578.84 181.47 579.33 178.65 577.28 176.65 580.11 176.24"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#90c9ff",
    points: "288.15 69.53 289.73 72.74 293.27 73.25 290.71 75.75 291.31 79.27 288.15 77.61 284.98 79.27 285.59 75.75 283.03 73.25 286.57 72.74"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#90c9ff",
    points: "642.65 226.45 644.23 229.65 647.77 230.17 645.21 232.66 645.82 236.19 642.65 234.52 639.49 236.19 640.09 232.66 637.53 230.17 641.07 229.65"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175.85,
    cy: 216.92,
    r: 4.19,
    fill: "#90c9ff"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 83.38,
    height: 83.37,
    x: 481.78,
    y: 56.83,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 1,
    result: "back"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 83.38,
    height: 83.37,
    x: 481.78,
    y: 56.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 83.38,
    height: 83.37,
    x: 481.78,
    y: 56.83,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 1,
    result: "back"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 234.554,
    x2: 303.865,
    y1: 287.666,
    y2: 334.022,
    gradientTransform: "scale(-1 1) rotate(44.854 128.14 -754.315)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M493.91,127.92c16.24,16.32,42.64,16.39,58.96,0.15c16.32-16.24,16.39-42.63,0.15-58.95 c-16.24-16.32-42.63-16.39-58.96-0.15C477.75,85.2,477.68,111.59,493.91,127.92z",
    mask: "url(#f)"
  })))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 234.554,
    x2: 303.865,
    y1: 287.666,
    y2: 334.022,
    gradientTransform: "scale(-1 1) rotate(44.854 128.14 -754.315)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M493.91,127.92c16.24,16.32,42.64,16.39,58.96,0.15c16.32-16.24,16.39-42.63,0.15-58.95 c-16.24-16.32-42.63-16.39-58.96-0.15C477.75,85.2,477.68,111.59,493.91,127.92z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 939.678,
    x2: 773.04,
    y1: 282.213,
    y2: 193.009,
    gradientTransform: "scale(-1 1) rotate(6.794 -708.403 -12288.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M573.16,415.18c-0.29-2.47,13.87-51.72,29.62-73.63c15.75-21.91,33.46-62.4,33.46-62.4 s5.96,36.01-10.42,59.66c-16.38,23.65-23.33,35.33-23.33,35.33s11.44-23.06,38.79-24.65c27.35-1.59,20.32,23.45,20.32,23.45 s-30.18-43.14-92.82,54.45"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 506.161,
    x2: 614.271,
    y1: 497.927,
    y2: 318.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M535.73,462.95c0,0-43,10.01-72.12-7.82c-29.11-17.82-48.2-43.11-48.2-43.11 s32.53-10.95,53.5-6.61c20.97,4.33,39.32,28.06,39.37,26.15c0.05-1.92-22.37-32.26-24.19-52.22 c-1.82-19.97,7.66-57.36,7.66-57.36s27.61,21.27,34.49,37.91c6.88,16.64,12.23,52.55,12.23,52.55s-3.66-31.41,9.07-57.47 c12.73-26.06,45.08-47.13,45.08-47.13s12.03,32.52,2.15,64.24c-9.88,31.72-32.76,52.58-32.76,52.58s31.66-22.85,51.2-25.98 c19.54-3.13,46.64,13.84,46.64,13.84s-27.71,30.83-49.15,36.37c-21.43,5.54-42.98,2.7-42.98,2.7s29.73,0.51,47.22,12.35 c17.49,11.83,32.39,36.25,32.39,36.25s-41.42,4.91-67.54-8.36C553.67,478.55,535.73,462.95,535.73,462.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 634.726,
    x2: 634.562,
    y1: 534.088,
    y2: 534.889,
    gradientTransform: "rotate(18.924 848.543 304.954)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M576.67,452.23c-5.36-0.57-8.95-0.64-8.95-0.64S571.18,452.03,576.67,452.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 558.873,
    x2: 574.841,
    y1: 423.079,
    y2: 423.079,
    gradientTransform: "rotate(-12.552 430.484 641.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M498.02,344.96c0,0,5.27,69.65,38.05,106.95c-4.58-10.43-16.87-28.32-23.69-53.08 C505.56,374.07,498.02,344.96,498.02,344.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 473.437,
    x2: 573.332,
    y1: 450.151,
    y2: 450.151,
    gradientTransform: "rotate(-12.552 430.484 641.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M535.18,454.83c0,0-61.64-17.86-85.46-28.95c-17.69-7.72-25.93-11.65-25.93-11.65 s13.36,10.89,51.51,25.6C513.46,454.55,535.18,454.83,535.18,454.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 580.583,
    x2: 663.785,
    y1: 514.698,
    y2: 514.698,
    gradientTransform: "rotate(-12.552 430.484 641.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M542.9,456.17c0,0,37.8,10.04,69.6,26.33c15.04,7.83,24.5,13.46,24.5,13.46 s-25.8-11.56-43.57-18.61C575.67,470.29,542.9,456.17,542.9,456.17z"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 263.105,
    x2: 96.467,
    y1: 342.559,
    y2: 253.355,
    gradientTransform: "rotate(6.783 42.654 366.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M250.14,395.06c0.29-2.47-13.87-51.72-29.62-73.63c-15.75-21.91-33.46-62.4-33.46-62.4 s-5.96,36.01,10.42,59.66c16.38,23.65,23.33,35.33,23.33,35.33s-11.44-23.06-38.79-24.65c-27.35-1.59-20.32,23.45-20.32,23.45 s30.18-43.14,92.82,54.45"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M550.67,288.47c0,0-17.7,26.51-28.78,65.04c-11.08,38.53-6.68,81.77-6.68,81.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M544.29 332.66c0 0-14.22 4.53-19.34 10.98.16-7.09 2.32-32.77 2.32-32.77M535.28 373.79c0 0-13.68 2.31-18.95 7.42-3.29-7.67-6.35-27.66-6.35-27.66M522.8 408.88c0 0-5.94 3.52-8.46 6.83-4.45-6.69-16.25-19.18-16.25-19.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M548.51 290.94c0 0 17.41-.52 25-12.54 7.59-12.02 9.11-22.49 9.11-22.49s-16.1 2.44-25.58 10.89C547.56 275.25 548.51 290.94 548.51 290.94zM544.29 332.66c0 0 9.51-14.76 22.41-20.85 11.41-4.6 27.05 3.94 27.05 3.94s-1.89 11.64-19.35 18.22C562.77 338.35 550.95 335.44 544.29 332.66zM510.87 357.05c0 0 6.09-24.76-5.32-34.52-11.4-9.76-15.85-12.06-15.85-12.06s-4.53 19.15.47 29.5C495.17 350.3 510.87 357.05 510.87 357.05zM531.85 374.37c0 0 15.07-14.46 26.34-14.47 11.28-.02 22.96 5.03 22.96 5.03s-7.07 14.43-24.56 14.86C539.09 380.21 531.85 374.37 531.85 374.37zM500.12 398.62c0 0-3.07-19.17-17.43-22.97-12.22-3.01-17.46-.19-17.46-.19s.59 9.38 7.78 17.23C480.21 400.53 500.12 398.62 500.12 398.62zM521.04 409.92c0 0 2.99-11.13 12.43-14.01 9.76-2.82 18.13 2.21 18.13 2.21s-1.22 11.62-12.16 14.29C528.5 415.08 521.04 409.92 521.04 409.92zM527.83 312.81c0 0 6.41-18.2 2.39-27-4.02-8.81-12.84-12.72-12.84-12.72s-6.85 10.17-4.37 19.96C515.48 302.84 527.83 312.81 527.83 312.81z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M247.95,292.46c0,0,24.85,19.96,47,53.38c22.15,33.42,30.96,75.98,30.96,75.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M267.31 332.68c0 0 14.93.04 21.75 4.66-2.28-6.72-12.06-30.56-12.06-30.56M288.27 369.2c0 0 13.75-1.91 20.3 1.38.83-8.3-2.26-28.29-2.26-28.29M310.72 398.91c0 0 6.72 1.57 10.12 3.97 2.24-7.72 9.73-23.18 9.73-23.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M250.75 294.16c0 0-16.77 4.74-27.61-4.45-10.85-9.19-15.45-18.71-15.45-18.71s16.09-2.52 27.67 2.7C246.94 278.91 250.75 294.16 250.75 294.16zM267.31 332.68c0 0-13.51-11.22-27.64-13.15-12.27-.96-24.61 11.89-24.61 11.89s5.3 10.53 23.93 11.56C251.4 343.66 261.8 337.33 267.31 332.68zM306.52 345.89c0 0-13.25-21.78-5.31-34.53 7.94-12.74 11.5-16.27 11.5-16.27s10.08 16.91 8.42 28.28C319.46 334.74 306.52 345.89 306.52 345.89zM291.72 368.72c0 0-18.72-9.26-29.48-5.88-10.76 3.38-20.39 11.7-20.39 11.7s11.08 11.64 27.9 6.79C286.57 376.48 291.72 368.72 291.72 368.72zM329.28 382.31c0 0-2.84-19.21 9.71-27.15 10.75-6.55 16.6-5.43 16.6-5.43s2.26 9.12-2.24 18.77C348.84 378.15 329.28 382.31 329.28 382.31zM312.71 399.38c0 0-6.2-9.72-16.06-9.63-10.15.25-16.62 7.55-16.62 7.55s4.66 10.72 15.89 9.98C307.15 406.54 312.71 399.38 312.71 399.38zM277.05 308.81c0 0-11.58-15.43-10.4-25.04 1.18-9.61 8.43-15.99 8.43-15.99s9.59 7.64 10.17 17.72C285.83 295.58 277.05 308.81 277.05 308.81z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 481.058,
    x2: 578.279,
    y1: 566.473,
    y2: 412.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59023f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#590444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#5a0a53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#5c156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#5e238f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#6135bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#644cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6551ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M514.94,549.99c0,0-37.16,23.84-70.57,16.81c-33.4-7.03-59.86-24.46-59.86-24.46 s26.98-21.21,48.19-24.16c21.21-2.95,46.46,13.26,45.86,11.44c-0.6-1.82-31.89-22.89-40.3-41.09 c-8.41-18.2-12.01-56.61-12.01-56.61s33.14,10.79,45.2,24.16c12.06,13.37,29.14,45.41,29.14,45.41s-13.98-28.37-10.72-57.19 c3.26-28.82,26.68-59.52,26.68-59.52s22.24,26.61,23.56,59.8c1.33,33.2-13.24,60.52-13.24,60.52s22.17-32.14,39.53-41.64 c17.36-9.5,48.58-2.6,48.58-2.6s-15.78,38.34-34.12,50.74c-18.34,12.41-39.59,16.95-39.59,16.95s28.18-9.48,48.63-4.2 c20.45,5.29,42.67,23.3,42.67,23.3s-37.38,18.51-66.43,14.76C537.07,558.67,514.94,549.99,514.94,549.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 611.121,
    x2: 610.958,
    y1: 574.778,
    y2: 575.579,
    gradientTransform: "rotate(-.659 -3500.617 6255.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M549.91,526.16c-5.24,1.26-8.65,2.39-8.65,2.39S544.68,527.82,549.91,526.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 517.537,
    x2: 533.504,
    y1: 446.413,
    y2: 446.413,
    gradientTransform: "rotate(-32.142 586.313 559.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M439.86,451.46c0,0,28.31,63.86,71.7,88.01c-7.81-8.3-25.39-21.03-40.11-42.07 C456.72,476.36,439.86,451.46,439.86,451.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 432.096,
    x2: 531.994,
    y1: 473.485,
    y2: 473.485,
    gradientTransform: "rotate(-32.142 586.313 559.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M511.7,542.53c0,0-64.06,3.84-90.22,1.37c-19.25-1.35-28.33-2.29-28.33-2.29 s16.24,5.79,57.12,6.85C491.14,549.53,511.7,542.53,511.7,542.53z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 305.816,
    x2: 80.376,
    y1: 457.117,
    y2: 336.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M296.7,460.14c0,0,40.9-16.62,54.41-47.97c13.51-31.35,14.53-63.01,14.53-63.01 s-32.89,9.81-47.52,25.45c-14.63,15.63-15.95,45.6-17.09,44.06c-1.14-1.54-0.32-39.25-10.35-56.62 c-10.03-17.36-39.33-42.45-39.33-42.45s-10.29,33.3-6.32,50.86c3.97,17.56,20.31,49.99,20.31,49.99s-15.12-27.78-40.55-41.73 c-25.43-13.95-64.01-12.52-64.01-12.52s8.92,33.51,35.28,53.73c26.36,20.22,57.08,24.07,57.08,24.07s-39.04-0.41-56.81,8.29 c-17.77,8.71-30.13,38.2-30.13,38.2s40.42,9.21,61.13,1.38c20.71-7.83,36.67-22.57,36.67-22.57s-23.99,17.55-31.46,37.31 c-7.47,19.76-5.56,48.29-5.56,48.29s36.67-19.87,50.36-45.77C291.04,483.23,296.7,460.14,296.7,460.14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 371.665,
    x2: 371.502,
    y1: 907.176,
    y2: 907.977,
    gradientTransform: "scale(-1 1) rotate(54.134 480.815 70.715)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M257.07,474.98c4.06-3.55,6.94-5.68,6.94-5.68S261.44,471.66,257.07,474.98z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 357.656,
    x2: 255.966,
    y1: 567.532,
    y2: 394.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59023f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#590444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#5a0a53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#5c156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#5e238f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#6135bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#644cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6551ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M331.78,548.38c0,0,39.15,20.41,71.79,10.41c32.64-10,57.43-29.73,57.43-29.73 s-28.77-18.71-50.16-19.74c-21.39-1.03-45.08,17.37-44.65,15.5c0.43-1.87,29.71-25.66,36.45-44.54 c6.74-18.88,6.89-57.46,6.89-57.46s-32.04,13.72-42.86,28.12c-10.81,14.4-24.95,47.84-24.95,47.84s11.38-29.51,5.55-57.92 c-5.83-28.41-31.9-56.89-31.9-56.89s-19.76,28.49-18.1,61.67c1.65,33.18,18.62,59.09,18.62,59.09s-24.96-30.02-43.1-37.93 c-18.14-7.91-48.62,1.77-48.62,1.77s19.15,36.77,38.53,47.48c19.37,10.71,40.95,13.33,40.95,13.33s-28.91-6.92-48.81,0.18 c-19.89,7.1-40.4,27.03-40.4,27.03s38.89,15.08,67.49,8.75C310.52,559.02,331.78,548.38,331.78,548.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M315.37,383.98c0,0,26.07,28.48,31.9,56.89c5.83,28.41-5.55,57.92-5.55,57.92s14.14-33.45,24.95-47.84 c10.81-14.4,42.86-28.12,42.86-28.12s-0.14,38.58-6.89,57.46c-6.74,18.88-36.02,42.68-36.45,44.54 c-0.43,1.87,23.26-16.54,44.65-15.5c21.39,1.03,50.16,19.74,50.16,19.74s-24.79,19.73-57.43,29.73 c-32.64,10-71.79-10.41-71.79-10.41s-0.37,0.18-1.05,0.51C334.04,476.46,315.37,383.98,315.37,383.98z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 235.804,
    x2: 235.641,
    y1: 809.65,
    y2: 810.451,
    gradientTransform: "scale(-1 1) rotate(4.485 3550.266 -6163.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M294.81,527.79c5.33,0.79,8.82,1.61,8.82,1.61S300.17,528.97,294.81,527.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 75.122,
    x2: 91.094,
    y1: 450.292,
    y2: 450.292,
    gradientTransform: "scale(-1 1) rotate(-26.996 -56.977 1408.051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M397.72,443.52c0,0-22.47,66.14-63.52,94.08c7.03-8.96,23.4-23.22,36.18-45.49 C383.16,469.83,397.72,443.52,397.72,443.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -10.319,
    x2: 89.584,
    y1: 477.367,
    y2: 477.367,
    gradientTransform: "scale(-1 1) rotate(-26.996 -56.977 1408.051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M334.34,540.66c0,0,64.15-1.92,89.98-6.72c19.05-3.07,28.01-4.82,28.01-4.82 s-15.65,7.22-56.27,11.95C355.44,545.8,334.34,540.66,334.34,540.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 95.552,
    x2: 210.583,
    y1: 501.678,
    y2: 501.678,
    gradientTransform: "scale(-1 1) rotate(-26.996 -56.977 1408.051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M328.38,539.21c0,0-24.21-25.12-46.73-41.56c-22.51-16.45-48.18-25.53-48.18-25.53 s33.71,20.19,46.35,29.27C292.45,510.47,328.38,539.21,328.38,539.21z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.73,237.32c0,0,4.36,21.59-17.93,33.39c-7.46,2.58-21.36,2.83-29.09-4.55 c11.34,5.51,21.44,6.43,28.9,3.52C311.85,266.15,324.03,261.53,325.73,237.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,239.55c0,0,4.87,18.47-6.28,30.7c-11.07-2.44-20.24-10.9-22.92-16.91 c3.59,4.13,13.38,13.87,22.4,16.06C311.22,262.27,315.41,253.3,313.79,239.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.23,249.74c0,0,5.64,12.82,1.67,20.06c-2.11-1.23-12.28-10.44-15.16-24.52 c4.22,7.86,5.71,14.87,14.53,22.48C308.4,262.94,306.6,251.66,306.23,249.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 321.755,
    x2: 331.407,
    y1: 176.067,
    y2: 176.067,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M326,242.01c0,0,3.24-1.9,3.59-6.76c0.36-4.86-2.52-6.6-4.03-4.52 c-0.65-1.47-1.31-0.74-1.32,0.21c-0.91-0.92-2.7-0.97-2.93,1.15C321.08,234.21,322.93,241.57,326,242.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 312.21,
    x2: 320.754,
    y1: 183.315,
    y2: 183.315,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M314.1,243.33c0,0,3.69-2.32,2-7.75c-1.05-2.8-2.49-3.01-2.82-2.27 c-0.41-0.33-2.13-0.59-2.22,0.89c-0.86-0.46-2.35,0.77-1.94,2.49C309.51,238.41,310.46,242.49,314.1,243.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 311.178,
    x2: 318.79,
    y1: 196.878,
    y2: 196.878,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M307.27,254.17c0,0,2.93-1.95,1.22-6.61c-1.09-3.16-2.63-2.1-2.65-1.43 c-0.59-0.89-1.59-0.72-1.7,0.07c-0.86-0.41-1.93,0.82-1.53,2.53C303.01,250.44,304.29,253.94,307.27,254.17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 294.66,
    x2: 305.468,
    y1: 197.055,
    y2: 197.055,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M294.4,249.66c0,0,2.82-1.35,2.05-5.7c-0.77-4.35-3.17-7.1-4.05-5.35 c-0.87-0.66-2.34-1.93-3.67,0.58c-1.59,0.37-1.33,2.84-0.63,4.65C288.79,245.64,291.37,249.79,294.4,249.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 290.637,
    x2: 303.269,
    y1: 224.422,
    y2: 224.422,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M283.89,269.23c0,0,0.84-3.02-2.94-5.3c-3.78-2.28-7.43-2.29-6.7-0.47 c-1.07,0.22-2.99,0.49-1.98,3.15c-0.77,1.44,1.26,2.87,3.09,3.53C277.18,270.8,282,271.59,283.89,269.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 290.605,
    x2: 300.803,
    y1: 209.143,
    y2: 209.143,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M287.02,256.26c0,0,1.36-1.38-0.33-4.36c-1.1-2.23-4.52-5.99-5.06-3.1 c-1.59,0.03-3.41-0.39-2.65,2.84c-1.45,0.84-0.16,2.37,1.31,3.86C281.77,256.98,285.59,257.49,287.02,256.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.52,268.42c0,0,0.06,0.11,0.18,0.34c1.96,3.77,19.45,38.11,12.43,48.75 c0.69-5.42-0.16-12.2-4.96-25.87c-4.8-13.67-9.17-22.25-9.17-22.25l1.59-0.85"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480.14,244.77c0,0-4.36,21.59,17.93,33.39c7.46,2.58,21.36,2.83,29.09-4.55 c-11.34,5.51-21.44,6.43-28.9,3.52C494.02,273.6,481.84,268.98,480.14,244.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.08,247c0,0-4.87,18.47,6.28,30.7c11.07-2.44,20.24-10.9,22.92-16.91 c-3.59,4.13-13.38,13.87-22.4,16.06C494.65,269.73,490.47,260.75,492.08,247z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.64,257.19c0,0-5.64,12.82-1.67,20.06c2.11-1.23,12.28-10.44,15.16-24.52 c-4.22,7.86-5.71,14.87-14.53,22.48C497.47,270.39,499.27,259.11,499.64,257.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 559.184,
    x2: 568.836,
    y1: 75.993,
    y2: 75.993,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M479.87,249.46c0,0-3.24-1.9-3.59-6.76c-0.36-4.86,2.52-6.6,4.03-4.52 c0.65-1.47,1.31-0.74,1.32,0.21c0.91-0.92,2.7-0.97,2.93,1.15C484.79,241.66,482.94,249.02,479.87,249.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 549.64,
    x2: 558.183,
    y1: 83.241,
    y2: 83.241,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M491.77,250.78c0,0-3.69-2.32-2-7.75c1.05-2.8,2.49-3.01,2.82-2.27 c0.41-0.33,2.13-0.59,2.22,0.89c0.86-0.46,2.35,0.77,1.94,2.49C496.36,245.87,495.41,249.95,491.77,250.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 548.608,
    x2: 556.22,
    y1: 96.804,
    y2: 96.804,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M498.6,261.62c0,0-2.93-1.95-1.22-6.6c1.09-3.16,2.63-2.1,2.65-1.43 c0.59-0.89,1.59-0.72,1.7,0.07c0.86-0.41,1.93,0.82,1.53,2.53C502.86,257.89,501.59,261.39,498.6,261.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 532.089,
    x2: 542.898,
    y1: 96.98,
    y2: 96.98,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M511.48,257.11c0,0-2.82-1.35-2.05-5.7c0.77-4.35,3.16-7.1,4.05-5.35 c0.87-0.66,2.34-1.93,3.67,0.58c1.59,0.37,1.33,2.84,0.63,4.65C517.08,253.09,514.5,257.24,511.48,257.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 528.067,
    x2: 540.698,
    y1: 124.347,
    y2: 124.347,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M521.98,276.68c0,0-0.84-3.02,2.94-5.3c3.78-2.28,7.43-2.29,6.7-0.47 c1.07,0.22,2.99,0.49,1.98,3.15c0.77,1.44-1.26,2.87-3.09,3.53C528.69,278.25,523.87,279.04,521.98,276.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 528.034,
    x2: 538.232,
    y1: 109.068,
    y2: 109.068,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M518.85,263.71c0,0-1.36-1.38,0.33-4.36c1.1-2.23,4.52-5.99,5.06-3.1 c1.59,0.03,3.41-0.39,2.65,2.84c1.45,0.84,0.16,2.37-1.31,3.86C524.1,264.44,520.29,264.94,518.85,263.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.35,275.88c0,0-0.06,0.11-0.18,0.34c-1.96,3.77-19.45,38.11-12.43,48.75 c-0.69-5.42,0.16-12.2,4.96-25.87c4.8-13.67,9.17-22.25,9.17-22.25l-1.59-0.85"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 415.485,
    x2: 415.485,
    y1: 615.037,
    y2: 544.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#6300b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#3800a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#190095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#07008e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 415.49,
    cy: 570.83,
    fill: "url(#M)",
    rx: 305.07,
    ry: 24.03
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 421.101,
    x2: 390.929,
    y1: 328.466,
    y2: 204.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M399.61,238.71l-33.52,57.83c0,0,41.07,36.04,48.61,32.69c7.54-3.35,44.42-17.6,44.42-17.6 s0.84-20.95-1.68-27.66c-2.51-6.7-33.52-55.31-36.04-53.64C418.88,232.01,399.61,238.71,399.61,238.71z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M270.8,499.03c1.68,1.12,14.81,19,32.97,31.57s42.74,24.86,42.74,24.86l136.89,2.23 c0,0,30.73-13.13,49.73-29.33c19-16.2,23.19-28.5,23.19-28.5l-113.42,8.66l-1.12-1.12l-56.99,0.56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 413.582,
    x2: 413.582,
    y1: 264.081,
    y2: 137.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M374.45,200.57c0,0,3.54,24.96,12.66,35.95s18.44,17.69,25.52,17.69c7.08,0,21.23-8.38,27.56-20.67 s9.13-32.59,9.13-32.59s14.71-35.57-17.13-39.48c-31.85-3.91-49.73-10.06-52.15-2.79C377.62,165.93,374.45,200.57,374.45,200.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.05,170.58c0.31-0.5,15.09,23.47,13.41,36.69s-6.33,26.26-9.5,30.36c-3.17,4.1-11.73,11.17-11.73,11.17 s-0.75,18.81,6.52,28.5s20.86,15.83,27.01,16.39c6.15,0.56,11.73,1.3,11.17,1.3c-0.56,0-8.75-25.33-5.59-43.21 c3.17-17.88-0.74-68.35-7.64-87.16c-6.89-18.81-11.36-20.3-11.36-20.3s-18.81-17.69-56.99-5.21c-22.04,7.2-27.01,32.03-26.82,59.04 c0.19,27.01,2.98,48.61-4.47,69.66c-7.45,21.05-5.96,27.38-5.96,27.38s28.31-0.56,36.69-9.13c8.38-8.57,10.43-14.71,10.99-21.6 c0.56-6.89,1.12-14.71,1.12-14.71s-14.16-8.01-19.37-23.47c-5.21-15.46-5.59-16.76-5.59-16.76s10.8-5.03,23.65-17.51 c12.85-12.48,14.15-15.09,14.15-15.09l-8.75,13.78C404.99,190.7,421.94,189.77,434.05,170.58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 343.072,
    x2: 329.662,
    y1: 304.562,
    y2: 435.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M366.63,293.97c0,0-21.23,0-26.54,7.26c-5.31,7.26-36.32,94.15-34.92,99.73s49.17,68.17,49.17,68.17 s1.4-33.8,1.12-35.48c-0.28-1.68-25.7-39.39-25.7-40.23s24.31-44.98,24.31-44.98L366.63,293.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 453.861,
    x2: 496.326,
    y1: 311.318,
    y2: 430.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M459.66,293.97c0,0,21.23,0,26.54,7.26s36.32,94.15,34.92,99.73s-49.17,68.17-49.17,68.17 s-1.4-33.8-1.12-35.48c0.28-1.68,25.7-39.39,25.7-40.23s-24.31-44.98-24.31-44.98L459.66,293.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 412.899,
    x2: 412.899,
    y1: 319.955,
    y2: 464.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dacff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#1b9fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#157dc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#0c4682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00002e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M457.14,292.85c0,0-12.57,18.16-41.63,19.56c-29.05,1.4-44.14-19-44.14-19l-4.75,0.56 c0,0-11.73,25.14-12.85,42.18c-1.12,17.04,1.96,24.86,6.15,32.97s7.82,8.94,7.82,8.94l1.68,114.54c0,0,77.66,8.38,77.39,7.54 c-0.28-0.84,15.64-121.25,15.64-122.36c0-1.12,9.22-19.84,9.78-33.52s-8.94-49.73-8.94-49.73L457.14,292.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 414.425,
    x2: 414.425,
    y1: 512.534,
    y2: 365.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#0a0b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#151a2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#252d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#3a477d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#5466b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#728af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7790ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M335.62,510.2c0,0-12.57-114.82-12.29-115.94c0.28-1.12-1.12-5.59,14.53-5.31c15.64,0.28,159.8,0,159.8,0 s8.66-1.68,7.82,9.78c-0.84,11.45-6.15,106.72-6.15,106.72L335.62,510.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.44,
    cy: 442.88,
    r: 12.01,
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 251.642,
    x2: 435.817,
    y1: 504.749,
    y2: 504.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#190c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000054"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M434.98,530.04c-0.52-1.8-35.48-17.32-45.26-25.42c-9.78-8.1-38.27-24.31-61.46-32.69 c-23.19-8.38-43.3-18.16-48.05-19.56c-4.75-1.4-13.69-2.51-22.35,8.94s-7.82,20.95-0.28,28.5c7.54,7.54,36.88,33.25,63.42,40.79 s45.54,11.45,66.21,17.32c20.67,5.87,33.52,10.06,33.52,10.06S440.01,547.36,434.98,530.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 423.618,
    x2: 523.441,
    y1: 562.617,
    y2: 562.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M423.62,556.58c0,0,9.5,0.84,12.57,3.07c3.07,2.23,8.94,5.59,12.01,5.59c3.07,0,13.97,1.68,21.51,5.03 c7.54,3.35,24.31,12.85,28.22,11.17c3.91-1.68,3.91-1.68,3.91-1.68s2.79,0,4.47-1.4c1.68-1.4,1.96-2.79,1.96-2.79s3.07,0,4.47-1.4 c1.4-1.4,1.4-3.91,1.4-3.91s2.51,0.28,3.35-1.4c0.84-1.68,0.84-1.68,0.84-1.68s3.07-1.96,4.19-4.19c1.12-2.23,1.12-2.51,0.56-3.35 c-0.56-0.84-11.73-8.38-14.25-8.38c-2.51,0-14.81-1.4-21.51-3.35c-6.7-1.96-11.17-2.51-24.03-4.19 C450.44,542.05,423.62,556.58,423.62,556.58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 397.638,
    x2: 581.813,
    y1: 505.867,
    y2: 505.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#190c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000054"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M398.48,531.16c0.52-1.8,35.48-17.32,45.26-25.42c9.78-8.1,38.27-24.31,61.46-32.69 c23.19-8.38,43.3-18.16,48.05-19.56c4.75-1.4,13.69-2.51,22.35,8.94s7.82,20.95,0.28,28.5c-7.54,7.54-36.88,33.25-63.42,40.79 c-26.54,7.54-45.54,11.45-66.21,17.32c-20.67,5.87-33.52,10.06-33.52,10.06S393.45,548.48,398.48,531.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 407.747,
    x2: 263.006,
    y1: 535.424,
    y2: 590.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M398.1,532.83c0,0-30.92,15.27-36.32,15.27s-6.71-1.86-9.31-2.98c-2.61-1.12-7.64-0.56-14.9,2.79 c-7.26,3.35-12.48,6.33-17.32,5.96c-4.84-0.37-14.71-3.35-20.3-0.56c-5.59,2.79-16.02,12.85-12.29,16.76 c3.73,3.91,13.41,8.2,17.51,5.96c4.1-2.23,15.46-2.79,24.77-1.86c9.31,0.93,19.74,3.91,27.01,1.3s20.11-10.06,31.1-12.85 c10.99-2.79,22.16-4.84,22.16-4.84S395.68,550.53,398.1,532.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M505.52,397.07c-0.09-9.61-7.87-8.12-7.87-8.12s-144.15,0.28-159.8,0c-15.64-0.28-14.25,4.19-14.53,5.31 c-0.02,0.09,0.03,0.86,0.15,2.2c1.3-1.86,2.89-4.99,11.92-4.99c10.43,0,161.29,0,161.29,0S502.37,391.19,505.52,397.07z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M606.57,574.41l-38.06-174.47l-4.43,0.63l2.56,11.75c0.67,0.74-17.03,0-17.03,0l-2.69-12.35l-4.56,0.04l38.25,175.34 c0.26,1.21,1.45,1.97,2.66,1.71c1.2-0.26,1.97-1.45,1.71-2.66l-2.8-12.85h17.03l3.01,13.8c0.26,1.21,1.45,1.97,2.66,1.71 S606.83,575.62,606.57,574.41z M550.44,416.14h17.03l2.69,12.35h-17.03L550.44,416.14z M553.97,432.3h17.03l2.7,12.35h-17.03 L553.97,432.3z M557.49,448.46h17.03l2.69,12.35h-17.03L557.49,448.46z M561.02,464.61h17.03l2.69,12.35h-17.03L561.02,464.61z  M564.54,480.77h17.03l2.69,12.35h-17.03L564.54,480.77z M568.07,496.93h17.03l2.69,12.35h-17.03L568.07,496.93z M571.59,513.09 h17.03l2.69,12.35h-17.03L571.59,513.09z M575.12,529.25h17.03l2.69,12.35h-17.03L575.12,529.25z M581.34,557.76l-2.69-12.35h17.03 l2.69,12.35H581.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 564.059,
    x2: 610.275,
    y1: 389.772,
    y2: 469.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#de5f28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    stopColor: "#b5615a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#906286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#7163ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5864ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#4565e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#3766f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#2f66fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c66ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M582.04,415.07c0.03,0.06,0.41,7.6-3.98,6.87c-2.47-0.41-3.58-10.48-8.1-17.36 c-1.06-1.61-4.88-12.49-5.69-14.16c-1.3-2.7,3.1-3.23,4.09-2.1c0.78,0.89,2.87,5.17,6.39,11.04 C578.74,405.97,581.27,413.14,582.04,415.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.9,498.18c-1.99-0.95-6.53-2.24-7.27-4.75c-0.02-0.07-0.02-0.13-0.04-0.2c-0.57-2.32,1.19-2.67,3.19-2.25 c2.05,0.43,8.08,1.54,8.08,1.54s1.06,2.5,1.06,3.98C588.92,498,585.86,499.12,583.9,498.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M587.67,491.22l0.16,1.1c0.06,0.43-0.15,0.86-0.54,1.06c-0.68,0.33-1.85,0.73-3.3,0.49 c-0.44-0.08-0.79-0.43-0.86-0.87l-0.2-1.39L587.67,491.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.64,514.79c-2.25-1.07-7.41-2.54-8.24-5.39c-0.03-0.08-0.02-0.15-0.04-0.22c-0.64-2.63,1.35-3.03,3.62-2.56 c2.33,0.49,9.17,1.75,9.17,1.75s1.23,2.87,1.23,5.01C585.37,515.52,581.86,515.85,579.64,514.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M583.92,506.89l0.18,1.24c0.53,1.78-2.71,2.03-4.35,1.75c-0.5-0.09-0.9-0.48-0.97-0.99l-0.23-1.58 L583.92,506.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 580.94,
    x2: 578.186,
    y1: 454.719,
    y2: 503.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#403372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#3e3677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#374086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#2b519f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#1c68c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#0885ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M588.97,449.63c0,0,1.21,3.84,1.54,8.51c0.41,5.86-5,12.08-4.5,15.91c0.9,6.89,2.84,14.09,3.04,16.15 c0.2,2.07-7.17,3.25-7.71,1.02c-0.54-2.23-5.85-13.72-6.42-16.99c-0.99-5.63,5.97-8.22,5.97-8.22s-0.7,15.92,0.16,20.64 c0.49,2.68,3.61,17.81,3.95,19.81c0.09,0.55-0.91,2.1-2.88,2.45c-2.09,0.37-4.54-0.19-4.87-1.03c-0.85-2.2-3.86-18.56-4.33-21.11 c-0.48-2.55-1.87-26.73-2.28-28.52C570.22,456.45,588.15,447.81,588.97,449.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 546.879,
    x2: 593.096,
    y1: 386,
    y2: 465.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#fc5e03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f45e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#e55f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#d06038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b66159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#956280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#6f63af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#4365e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c66ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M565.81,423.34c-0.04,7,4.33,35.61,5.22,35.92c5.58,1.92,19.13-6.22,18.95-8.42 c-1.19-14.41-5.89-35.71-8.73-36.41C575.28,412.94,565.83,419.91,565.81,423.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 541.968,
    x2: 576.298,
    y1: 370.424,
    y2: 370.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M576.3,370.42c0,9.48-7.68,17.17-17.17,17.17c-9.48,0-17.16-7.69-17.16-17.17 c0-9.48,7.68-17.16,17.16-17.16C568.61,353.26,576.3,360.94,576.3,370.42z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#431ca3",
    fontFamily: "MyriadPro-Bold",
    fontSize: 12.67,
    transform: "translate(547.276 376.03)"
  }, "PHP"), /*#__PURE__*/React.createElement("path", {
    fill: "#f4a477",
    d: "M554.01,449.38c-0.85,0.54-1.33,1.12-1.93,2.02c-0.9,1.29,1,5.19,2.19,4.09c-0.24-1.22,1.54-1.81,2.18-2.12 c2.11-1,2.32-2.03,2.18-2.83C558.24,448.35,556.65,447.7,554.01,449.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 559.375,
    x2: 576.767,
    y1: 451.253,
    y2: 417.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#fb5e04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f15f11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#df5f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c76044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#a7616a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#806399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#5464cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c66ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M565.02,440.45c-0.17,2.48-7.03,5.89-8.07,7.44c-0.95,1.42-0.13,3.51,2.53,3.32 c1.35-0.14,12.61-6.26,12.86-8.57c0.45-4.19,0.55-22.42-4.62-21.92C563.3,421.14,565.2,437.97,565.02,440.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4a477",
    d: "M576.18,404c-0.7-4.77-4.56-6.69-9.48-4.56c-5.88,2.56-3.49,7.2-3.12,9.23c0.47,2.62,1.59,7.78,3.05,8.18 c1.05,0.29,1.8-0.19,2.9-0.56c0.38,1.41,0.33,2.18,0.56,2.37c1.07,0.89,6.23-1.47,6.03-3.18c-0.09-0.78-0.24-2.07-0.33-3.35 C575.41,408.77,576.76,407.9,576.18,404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078a2",
    d: "M569.27,407.74c-0.9-0.37-1.8,0.14-2.18,1.99c-0.03,0.14-0.93,0.49-0.91,0.22 c0.63-6.3-2.27-4.52-2.91-5.55c-0.03-2.79,1.01-4.93,4.08-5.87c4.99-1.53,9.86,0.67,10.56,5.45c0.48,3.27-1.77,5.51-1.65,8.78 c0.02,0.45-0.29,0.32-1.24,0.55c-0.74,0.18-1.6,1-2.36,0.86c-0.95-0.18-3.04-2.1-2.79-3.36 C570.11,409.66,570.19,408.12,569.27,407.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 580.729,
    x2: 583.543,
    y1: 475.156,
    y2: 475.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#100060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090e96"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M582.5,491.8c0,0-1.95-12.32-1.76-14.97c0.19-2.65,0.92-16.64,0.92-16.64l1.88-1.68 c0,0-1.86,15.59-1.62,20.19S582.5,491.8,582.5,491.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4a477",
    d: "M563.87,388.89c-0.44-0.78,0.01-3.64,0.7-5.41c0.74-1.91,2.06-5.73,3.11-5.25c0.66,0.3-0.24,3.21-0.24,6.31 c0,1.97-0.53,3.88-0.86,4.76C566.34,389.96,564.47,390.05,563.87,388.89z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: -6.381,
    x2: -31.208,
    y1: 367.299,
    y2: 321.193,
    gradientTransform: "matrix(-1 0 0 1 276.51 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M314.58,347.9c0-11.73-9.51-21.24-21.24-21.24c-11.73,0-21.24,9.51-21.24,21.24 c0,11.73,9.51,21.24,21.24,21.24C305.07,369.15,314.58,359.64,314.58,347.9z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#125cae",
    fontFamily: "MyriadPro-Bold",
    fontSize: 17.406,
    transform: "translate(274.01 353.264)"
  }, "CSS3"), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M280.35,451.86c0,0-0.06,1.03-0.09,1.9c-0.01,0.23-0.01,0.45-0.01,0.64c0,0.27,1.38,0.49,2.51,0.18 c0.89-0.24,1.66-0.93,1.3-1.34c-0.38-0.42-0.77-1.9-0.77-1.9L280.35,451.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.27,453.76c0,0,2.07,0.9,3.8-0.52c0.93-0.04,8.83,1.69,8.04,2.95c-0.8,1.28-11.03,1.8-11.93,1.12 C279.83,457.05,279.91,454.63,280.27,453.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebbeaf",
    d: "M263.81,449.69c0,0-0.18,1.01-0.3,1.87c-0.03,0.23-0.06,0.44-0.08,0.64c-0.03,0.27,1.32,0.64,2.48,0.46 c0.91-0.14,1.76-0.74,1.44-1.19c-0.33-0.46-0.56-1.97-0.56-1.97L263.81,449.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.76 408.82l-6.91-2.81c-.49 7.12.2 12.77-1.81 23.51-.85 4.52-4.99 15.04-6.6 20.19.47 1.1 5.13 1.23 5.77.08.83-1.76 6.26-11.77 7.75-18.17C276.64 428.66 277.79 415.98 277.76 408.82zM263.51 451.57c0 0 1.95 1.13 3.83-.09.93.06 8.6 1.59 7.75 3.27-.34.67-11.24 1.12-12.06.35C262.72 454.79 263.07 452.4 263.51 451.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M273.48,376.16c0,0,0.61-2.05,0.45-3.06c-0.16-1.01-2.43-2.39-2.79-4.5c-0.36-2.11,0.86-4.94,4.02-5.16 c4.77-0.34,4.62,3.39,4.79,4.68c0.28,2.09,0.06,5.42-0.42,5.65c-0.14,0.07-0.73,0.14-1.76-0.21c-0.18,0.52-0.64,2.95-0.29,3.7 C277.83,378.01,273.48,376.16,273.48,376.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.09,401.45c-0.24,1.56-0.4,3.28-0.25,4.57c0.76,6.19,5.35,13.95,6.91,24.28c0.69,4.55,1.03,16.92,1.23,21.73 c0.59,1.05,5.23,0.65,5.74-0.55c-0.51-2.26,1.83-17.42,1.17-25.11c-0.28-3.29-5.09-26.19-5.09-26.19S274.29,399.61,271.09,401.45 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 1253.161,
    x2: 1261.105,
    y1: 314.902,
    y2: 283.896,
    gradientTransform: "rotate(-8.969 1383.481 6602.967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#eb3300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f80"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M277.92,376.44c0,0-2.96-1.92-5.37-1.54c-0.34,0.22-0.45,1.27-0.91,2.54c-0.5,1.39-1.34,3.08-1.54,4.99 c-0.34,3.35,0.3,12.44-0.33,20.89c0.99,1.59,8.64,4.04,12.68,0.45c0,0-1.05-5.19-1.29-9.39c-0.25-4.35,2.7-4.81,2.14-8.24 c-0.36-2.2-4.38-4.81-5.47-8.12C277.69,377.58,278,376.93,277.92,376.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 1255.28,
    x2: 1267.689,
    y1: 281.138,
    y2: 254.549,
    gradientTransform: "rotate(-8.969 1383.481 6602.967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#2f1109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#7a3e25"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M279.65,363.88c1.57,3.57-3.26,3.38-4.51,9.82c-0.81,4.16-5.2,5.58-5.04,11.86 c-2.76-0.54-3.94-5.06-1.01-10.21c1.88-3.3,0.35-6.68,0.88-9.31C271.03,360.81,278.17,360.53,279.65,363.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M273.4,382.33c0.29-2.28,2.48-2.18,6.37-2.82c1.82-0.3,5.17-0.98,7.75-1.87c1.05-0.36,2.58-10.84,2.73-13.66 c0.06-1.22-0.82-1.49-1.36-2.51c-0.53-1.01-0.85-2.73-0.31-2.9c0.4-0.13,0.72,1.42,1.02,1.49c-0.11-1.2-0.45-3.03,0.02-4.23 c0.47-1.2,2.21-0.43,2.62-0.04c0.5,0.47,0.65,1.22,0.74,2.3c0.12,1.29,0.59,3.01,0.18,3.88c-0.35,0.76-0.68,1.79-0.67,2.33 c0.01,0.54-0.14,15.66-1.48,16.55c-1.82,1.21-6.88,2.79-11.55,3.6C275.76,385.08,273.17,384.12,273.4,382.33z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 650.5,
    x2: 606.705,
    y1: 497.21,
    y2: 455.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M600.62,475.05c0-14.62,11.85-26.47,26.47-26.47c14.62,0,26.47,11.85,26.47,26.47 c0,14.62-11.85,26.47-26.47,26.47C612.47,501.51,600.62,489.66,600.62,475.05z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#731ba3",
    fontFamily: "MyriadPro-Bold",
    fontSize: 19.958,
    transform: "translate(605.441 481.498)"
  }, "Java"), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M654.03,451.15l2.53,0.95c0.82,0.31,1.47,0.96,1.78,1.78l1.21,3.24c0.45,1.21,0.53,2.53,0.23,3.78 c-0.41,1.71-1.23,3.28-2.37,4.61c5.24,0.73,9.46,0.84,14.6-0.04c-1.36-4.25-2.4-7.95-5.36-11.31l-1.12-1.33 c0.39-0.07,1.37-8.96,0.17-11.01c-2.34-4-7.09-3.16-8.45-2.22c-1.97,1.59-1.52,3.45-2.27,4.2c-0.83,0.84-1.52,0.87-1.56,1.21 c-0.04,0.34,0.41,0.65,0.55,0.87c-0.17,1.68-0.86,3.02-0.83,4.06C653.16,450.37,653.61,450.99,654.03,451.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f58f9e",
    d: "M658.34,453.88l0.56,1.5c-0.48-2.45,1.36-3.59,1.36-3.59c-0.01,0-0.93,0.33-2.42,0.24 c-0.72-0.04-1.78-0.28-2.3-0.42c-0.52-0.15-1.27-0.37-1.27-0.37l0,0l2.29,0.86C657.38,452.4,658.03,453.05,658.34,453.88z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M693.88,550.19c0,0,1.01,1.28,3.16,2.64c2.1,1.32,4.2,2.62,3.89,3.24c-0.31,0.62-5.32,7.94-8.25,9.63 c-2.93,1.7-0.42-1.49-0.26-2.26c0.16-0.77,1.65-4.44,0.42-6.14c-1.23-1.69-2.7-2.7-2.31-3.47 C690.91,553.06,692.84,549.67,693.88,550.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.42 503.18c0 0-.47 20.6 2 24.3 2.47 3.7 17.62 16.75 20.91 23.32 0 0-2.05 4.93-5.75 4.73 0 0-8.49-9.97-14.74-13.7-5.33-3.18-8.48-5.92-9.61-8.7-1.13-2.78-9.56-28.98-9.56-28.98L672.42 503.18zM697.98 553.42c0 0 .64 1.72-1.25 2.87-1.6.97-4.15.78-4.02 2.41.14 1.79-.35 4.83-1.79 6.59-1.05 1.29-4.08 3.73-3.4 4.33.49.44 5.4 1.25 10.76-4.01 5.63-5.53 5.8-8.41 5.55-9C703.48 555.86 700.87 553.82 697.98 553.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M652.23,560c0,0,0.08,4.32-0.31,5.39c-0.39,1.08-9.32,0.92-11.33-0.77c-2-1.7,4.78-2.08,6.09-3.4 c0.59-0.59,1.25-2.23,1.25-2.23L652.23,560z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.8 491.21c0 0 2.32 6 1.98 10.34-.65 8.38-11.43 26.34-12.67 30.04-1.23 3.7 1.34 9.45-1.13 15.41-2.47 5.96-6.78 13.56-6.88 13.97-.1.41-5.22.94-6.33-1.68 1.09-3.54 3.05-10.22 3.77-16.29.72-6.06 1.93-13.92 2.14-17.72.21-3.8 5.06-33.47 5.06-33.47S659.78 492.13 671.8 491.21zM652.2 562.8c0 0-.59 2.59-3.16 1.92-2.57-.67-1.54-2.32-2.41-2.99-.54-.42-1.82-.16-4.64.47-3.58.8-9.3 1.17-9.31 3.19 0 .98 4.37 3.33 9.59 3.9 5.22.57 10.31-.51 10.87-.82C653.72 568.16 653.29 564.42 652.2 562.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 316.542,
    x2: 321.946,
    y1: 500.379,
    y2: 456.627,
    gradientTransform: "translate(345.057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M659.23,460.81c0.73-2.78,4.25-4.94,7.37-4.25c2.55,0.56,5.61,5.57,6.12,9.48 c0.51,3.9-1.92,21.11,0.77,27.43c0,0-13.68,4.34-19.02,2.53c0,0,1.67-6.07,2.19-10.64c0.97-8.55-2.6-9.52-2.49-14.21 C654.25,468.2,658.66,462.97,659.23,460.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M665.91,462.68c2.03-0.39,3.76,1.42,4.52,6.75c0.96,6.69,1.99,16.39,1.41,19.44 c-0.33,1.7-10.78-0.48-20.1-3.67c-1.43-0.49-3.39,1.18-4.72,1.07c-2.59-0.22-6.63-1.43-6-2.83c0.37-0.83,3.04-1.3,2.9-1.41 l-3.27-1.23c0.08-0.8,1.85-0.55,3.63-0.88c2.62-0.47,4.91,0.01,7.48,0.98c1.83,0.69,10.53,2.54,13.9,1.92 c-0.54-3.76-1.26-8.39-1.64-10.79C663.15,466.47,662.66,463.31,665.91,462.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 321.33,
    x2: 322.322,
    y1: 460.548,
    y2: 474.899,
    gradientTransform: "translate(345.057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M663.23,472.55c2.17-0.48,4.35-0.65,6.58-0.8c0.51-0.03,1.01-0.07,1.52-0.1 c-0.09-0.82-0.19-1.62-0.3-2.37c-0.76-5.33-3.22-8.41-5.29-7.74c-3.11,1.01-3.46,4.95-2.6,10.5 C663.17,472.2,663.2,472.37,663.23,472.55z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M664.9,437.36c-4.14-1.52-7.17,1.17-7.64,2.23c3.15,0.39,0.9,3.65,3.21,5.4c2.14,1.62,1.13,4.04,1.56,8.27 c0.7,6.82,8.93,5.46,10.46,11.57c3.08-7.93-4.51-11.66-3.66-16.88C669.7,442.59,668.33,438.62,664.9,437.36z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 219.334,
    x2: 262.076,
    y1: 485.371,
    y2: 439.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 242.47,
    cy: 460.42,
    r: 26.71,
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#431ca3",
    fontFamily: "MyriadPro-Bold",
    fontSize: 21.155,
    transform: "matrix(.6795 0 0 1 219.526 467.587)"
  }, "HTML5"), /*#__PURE__*/React.createElement("path", {
    fill: "#684204",
    d: "M218.43,437.87l-2.85,1.06c-0.93,0.35-1.66,1.08-2,2l-1.36,3.64c-0.51,1.36-0.6,2.85-0.26,4.26 c0.46,1.92,1.38,3.7,2.67,5.2c-5.91,0.82-10.66,0.95-16.45-0.05c1.53-4.79,2.7-8.96,6.03-12.74l1.26-1.5 c-0.44-0.08-1.55-10.09-0.2-12.41c2.63-4.51,7.98-3.56,9.52-2.5c2.22,1.79,1.71,3.88,2.56,4.73c0.94,0.94,1.72,0.98,1.76,1.36 c0.05,0.38-0.46,0.74-0.62,0.98c0.19,1.89,0.97,3.4,0.93,4.57C219.41,436.99,218.91,437.69,218.43,437.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.54,549.43c0,0-1.14,1.44-3.56,2.97c-2.36,1.49-4.73,2.95-4.39,3.65c0.35,0.69,5.99,8.94,9.29,10.85 c3.3,1.91,0.47-1.68,0.3-2.55c-0.17-0.87-1.86-5.01-0.47-6.92c1.39-1.91,3.04-3.04,2.6-3.91 C176.88,552.67,174.71,548.85,173.54,549.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 739.95,
    x2: 784.627,
    y1: 525.963,
    y2: 525.963,
    gradientTransform: "matrix(-1 0 0 1 956.533 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3113c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#2f18c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#2927cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#1f40d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#1263e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#008fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M197.71,496.47c0,0,0.53,23.21-2.25,27.38c-2.78,4.17-19.85,18.87-23.55,26.27c0,0,2.31,5.55,6.48,5.32 c0,0,9.56-11.23,16.6-15.43c6-3.58,9.55-6.67,10.83-9.8c1.27-3.13,10.76-32.64,10.76-32.64L197.71,496.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.92,553.08c0,0-0.72,1.94,1.41,3.24c1.8,1.1,4.68,0.88,4.53,2.72c-0.16,2.01,0.39,5.45,2.02,7.43 c1.19,1.45,4.6,4.2,3.83,4.88c-0.55,0.49-6.08,1.41-12.11-4.51c-6.35-6.23-6.54-9.48-6.25-10.13 C162.73,555.81,165.67,553.52,168.92,553.08z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220.46,560.48c0,0-0.09,4.86,0.35,6.08c0.43,1.22,10.5,1.04,12.76-0.87c2.26-1.91-5.38-2.35-6.86-3.82 c-0.66-0.66-1.4-2.51-1.4-2.51L220.46,560.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 754.292,
    x2: 742.265,
    y1: 474.085,
    y2: 536.054,
    gradientTransform: "matrix(-1 0 0 1 956.533 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M198.41,482.99c0,0-2.61,6.76-2.23,11.65c0.73,9.44,12.88,29.67,14.27,33.84 c1.39,4.17-1.5,10.65,1.27,17.36c2.78,6.71,7.64,15.28,7.76,15.74c0.12,0.46,5.89,1.05,7.12-1.9 c-1.22-3.99-3.43-11.52-4.24-18.35c-0.81-6.83-2.18-15.68-2.41-19.96c-0.23-4.28-5.7-37.7-5.7-37.7 S211.95,484.03,198.41,482.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.49,563.64c0,0,0.67,2.92,3.56,2.17c2.89-0.75,1.74-2.62,2.71-3.36c0.61-0.47,2.05-0.18,5.22,0.53 c4.03,0.9,10.48,1.32,10.48,3.59c0,1.11-4.92,3.76-10.8,4.39c-5.88,0.64-11.61-0.58-12.25-0.93 C218.78,569.68,219.27,565.47,220.49,563.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 746.627,
    x2: 752.715,
    y1: 493.322,
    y2: 444.035,
    gradientTransform: "matrix(-1 0 0 1 956.533 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#eb3300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f80"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M212.57,448.75c-0.82-3.13-4.79-5.56-8.31-4.79c-2.88,0.63-6.32,6.27-6.9,10.67 c-0.58,4.4,2.16,23.78-0.87,30.9c0,0,15.4,4.89,21.42,2.85c0,0-1.89-6.84-2.47-11.98c-1.09-9.63,2.93-10.72,2.8-16.01 C218.18,457.07,213.21,451.18,212.57,448.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#684204",
    d: "M205.05,450.86c-2.28-0.44-4.23,1.6-5.09,7.6c-1.08,7.53-2.24,18.46-1.58,21.89 c0.37,1.92,12.14-0.54,22.65-4.13c1.61-0.55,3.81,1.33,5.32,1.2c2.91-0.25,7.46-1.61,6.76-3.19 c-0.42-0.94-3.42-1.47-3.26-1.59l3.69-1.38c-0.09-0.9-2.08-0.62-4.09-0.99c-2.95-0.53-5.54,0.01-8.43,1.1 c-2.06,0.78-11.86,2.86-15.65,2.16c0.61-4.23,1.42-9.45,1.84-12.15C208.16,455.13,208.71,451.56,205.05,450.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 752.022,
    x2: 753.139,
    y1: 448.453,
    y2: 464.62,
    gradientTransform: "matrix(-1 0 0 1 956.533 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#fc5e03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f45e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#e55f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#d06038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b66159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#956280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#6f63af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#4365e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c66ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M208.06,461.97c-2.44-0.55-4.9-0.74-7.41-0.91c-0.57-0.04-1.14-0.08-1.71-0.12 c0.11-0.92,0.22-1.82,0.34-2.67c0.86-6,3.63-9.47,5.96-8.71c3.5,1.14,3.9,5.57,2.93,11.83 C208.14,461.57,208.1,461.77,208.06,461.97z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.19,422.33c4.67-1.71,8.07,1.32,8.6,2.51c-3.54,0.43-1.02,4.11-3.61,6.08c-2.41,1.82-1.27,4.55-1.76,9.32 c-0.79,7.68-10.07,6.15-11.78,13.03c-3.47-8.93,5.08-13.14,4.13-19.01C200.78,428.22,202.33,423.75,206.19,422.33z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomenWebDeveloperWithLaptop);
export default __webpack_public_path__ + "static/media/women-web-developer-with-laptop.5c0c9b08ffebb55fc01c57fc7a171714.svg";
export { ForwardRef as ReactComponent };